var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupervisorAccountFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 15q-1.05 0-1.775-.725T14.5 12.5t.725-1.775T17 10t1.775.725.725 1.775-.725 1.775T17 15m-4 5a.97.97 0 0 1-.713-.288A.97.97 0 0 1 12 19v-.4q0-.6.313-1.113a1.76 1.76 0 0 1 .887-.737q.9-.375 1.863-.562a10.1 10.1 0 0 1 3.874 0 9.6 9.6 0 0 1 1.863.562q.575.225.887.738Q22 18 22 18.6v.4q0 .424-.288.712A.97.97 0 0 1 21 20zm-3-8q-1.65 0-2.825-1.175T6 8t1.175-2.825T10 4t2.825 1.175T14 8t-1.175 2.825T10 12m-8 5.2q0-.85.425-1.562A2.8 2.8 0 0 1 3.6 14.55q1.5-.75 3.113-1.15Q8.324 13 10 13q.875 0 1.75.15t1.75.35l-1.7 1.7q-.625.625-1.213 1.275A2.2 2.2 0 0 0 10 18v.975q0 .3.113.563.112.262.362.462H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisorAccountFill);
export default __webpack_public_path__ + "static/media/supervisor_account_fill.78326dda059c950451e26b6da3bbfffa.svg";
export { ForwardRef as ReactComponent };